import { delay } from '$lib/utils/delay.js';

export async function temporizePromise<T>(
    delayInMs: number,
    promise: Promise<T>,
): Promise<T> {
    const [result] = await Promise.all([promise, delay(delayInMs)]);

    return result;
}
